import React, { Component } from 'react';
import { connect } from 'react-redux';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import './WorkOrderDetails.css';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import { usersUtil, TYPES, ROLES } from 'services/utils/users-util';
import {
  initializeComponentAppState,
  loadMembersRequest,
  loadQuotesRequest,
  loadTradesRequest,
  loadWorkOrderRequest,
  selectNavigationBar,
  selectTaskRequest,
  setCurrentWorkOrder,
  editWorkOrderName,
  changeWorkOrderName,
  saveWorkOrderNameRequest,
  editWorkOrderJobNumber,
  changeWorkOrderJobNumber,
  saveWorkOrderJobNumber,
} from 'actions/admin/work-orders/details/details';
import {
  getBudget,
  getContractorInvoice,
  getContractorLienRelease,
  getContractorLienReleases,
  getMembers,
  getNavigationBarSelectedItem,
  getOpenItemsByTaskId,
  getProposals,
  getQuotes,
  getWorkOrderJobNumberEdit,
  getWorkOrderJobNumberSaving,
  getWorkOrderJobNumberValue,
  getWorkOrderNameSaving,
  getWorkOrderAuthorizations,
} from 'selectors/admin/work-orders/details/details';

import DetailsTasks from './DetailsTasks';
import DetailsQuotes from './DetailsQuotes';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import {
  WorkOrderStatusEnum,
  WorkOrderStatusKeys,
} from 'services/utils/work-order-status-enum';
import { getCurrentUser } from 'selectors/authentication';
import numeral from 'numeral';
import DetailsMembers from './DetailsMembers';
import { setShowAddMemberModalRequest } from 'actions/admin/work-orders/details/members';
import DetailsOpenItems from './DetailsOpenItems';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { getSelectedProposalId } from 'selectors/admin/work-orders/details/proposal-approval';
import ProposalApprovalModal from './proposals/ProposalApprovalModal';
import WorkOrderValueEditor from 'components/admin/work-orders/details/WorkOrderValueEditor';
import {
  getWorkOrderNameEdit,
  getWorkOrderNameValue,
} from 'selectors/admin/work-orders/details/details';
import { WorkOrder } from 'domain/work-order';
import DetailsBudget from 'components/admin/work-orders/details/budget/DetailsBudget';
import { PermissionsUtil } from 'services/utils/permissions-util';
import { ProposalStatus } from 'domain/proposal-status-enum';
import DetailsPurchaseOrder from 'components/admin/work-orders/details/purchase-order/DetailsPurchaseOrder';
import BudgetApproveReviewModal from 'components/admin/work-orders/details/budget/BudgetApproveReviewModal';
import DetailsContractorsInvoices from 'components/admin/work-orders/details/contractors-invoices/DetailsContractorsInvoices';
import DetailsContractorsLienReleases from 'components/admin/work-orders/details/contractors-lien-releases/DetailsContractorsLienReleases';
import DetailsContractorsLienReleasesTable from 'components/admin/work-orders/details/contractors-lien-releases/DetailsContractorsLienReleasesTable';
import ReceiptsTable from 'components/admin/work-orders/details/receipts/ReceiptsTable';
import TimeTable from 'components/admin/work-orders/details/time/TimeTable';
import DetailsSchedule from 'components/admin/work-orders/details/schedule/DetailsSchedule';
import { timeSelector } from 'components/admin/work-orders/details/time/store/selectors';
import { vendorInvoicesSelector } from 'components/admin/work-orders/details/vendor-invoices/store/selectors';
import VendorInvoicesDetails from 'components/admin/work-orders/details/vendor-invoices/VendorInvoicesDetails';
import WorkOrderDetailsHeader from 'components/admin/work-orders/details/WorkOrderDetailsHeader';
import WorkOrderDetailsInfo from 'components/admin/work-orders/details/WorkOrderDetailsInfo';
import TransferWorkOrder from 'components/admin/work-orders/details/transfer/TransferWorkOrder';
import { receiptsSelector } from 'components/admin/work-orders/details/receipts/store/selectors';
import AnticipatedCostReport from 'components/admin/work-orders/details/anticipated-cost-report/AnticipatedCostReport';
import { loadChangeOrderTasksRequest } from 'components/admin/work-orders/details/change-order-tasks/store/actions';
import { loadChangeOrdersRequest } from 'components/admin/work-orders/details/change-orders/store/actions';
import ChangeOrderApprovalModal from 'components/admin/work-orders/details/change-orders/ChangeOrderApprovalModal';
import {
  getChangeOrders,
  getSelectedChangeOrderId,
} from 'components/admin/work-orders/details/change-orders/store/selectors';
import WorkOrderAuthorizations from 'components/admin/work-orders/details/work-order-authorizations/WorkOrderAuthorizations';

class WorkOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.userIsAdmin =
      usersUtil.isAdmin(this.props.user) ||
      usersUtil.hasType(this.props.user, TYPES.GENERAL_CONTRACTOR);
    this.userIsSpackleAdmin =
      usersUtil.hasRole(this.props.user, ROLES.SPACKLE_ADMIN) ||
      usersUtil.hasType(this.props.user, TYPES.GENERAL_CONTRACTOR);
    this.userIsContractor = usersUtil.hasType(
      this.props.user,
      TYPES.CONTRACTOR
    );
    this.userIsClient = usersUtil.hasType(this.props.user, TYPES.CLIENT);
    this.userIsGc = usersUtil.hasType(
      this.props.user,
      TYPES.GENERAL_CONTRACTOR
    );
    this.contractorUserCanSeeMoney = PermissionsUtil.contractorUserCanSeeMoney(
      this.props.user
    );
    this.adminUserCanSeeMoney =
      PermissionsUtil.adminUserCanSeeMoney(this.props.user) ||
      usersUtil.hasType(this.props.user, TYPES.GENERAL_CONTRACTOR);
  }

  initializeComponent() {
    this.props.dispatch(initializeComponentAppState());

    this.workOrderId = numeral(this.props.match.params.woId).value();

    this.props
      .dispatch(
        loadWorkOrderRequest(
          this.workOrderId,
          this.userIsAdmin,
          this.userIsContractor,
          this.contractorUserCanSeeMoney
        )
      )
      .then((response) => {
        if (response.ok) {
          // If work order is loaded, load task and members (if possible)
          this.props.dispatch(setCurrentWorkOrder(this.props.currentWorkOrder));

          // Load task
          if (this.props.match.params.hasOwnProperty('taskId')) {
            this.props.dispatch(loadTradesRequest());
            this.props.dispatch(
              selectTaskRequest(
                this.workOrderId,
                this.props.match.params.taskId,
                this.props.user
              )
            );
          }

          // Load members
          if (
            WorkOrderDetails.showMembers(
              response.workOrder.status,
              this.props.user
            )
          ) {
            // At this point current user is a contractor
            this.props.dispatch(loadMembersRequest(response.workOrder.id));
          }
        }
      });

    this.props.dispatch(loadQuotesRequest(this.workOrderId));
    this.props.dispatch(loadChangeOrderTasksRequest(this.workOrderId));

    if (this.userIsAdmin || this.userIsClient) {
      this.props.dispatch(loadChangeOrdersRequest(this.workOrderId));
    }
  }

  componentDidMount() {
    this.initializeComponent();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.woId !== this.props.match.params.woId) {
      // This happens if on one WO, another one is opened (so, we should refresh everything)
      this.initializeComponent();
    }
  }

  handleNavigationItemSelect = (value) => {
    simpleScrollToTop();
    this.props.dispatch(
      selectNavigationBar(this.props.currentWorkOrder.id, value)
    );
  };

  handleAddMember = (event) => {
    event.preventDefault();
    this.props.dispatch(setShowAddMemberModalRequest());
  };

  handleWorkOrderJobNumberChange = (value) => {
    this.props.dispatch(changeWorkOrderJobNumber(value));
  };

  handleWorkOrderJobNumberEdit = () => {
    this.props.dispatch(editWorkOrderJobNumber(true));
  };

  handleWorkOrderJobNumberSave = () => {
    this.props.dispatch(
      saveWorkOrderJobNumber(
        this.props.currentWorkOrder.id,
        this.props.workOrderJobNumberValue,
        this.props.currentWorkOrder.work_order_job
      )
    );
  };

  handleWorkOrderNameChange = (value) => {
    this.props.dispatch(changeWorkOrderName(value));
  };

  handleWorkOrderNameEdit = () => {
    this.props.dispatch(editWorkOrderName(true));
  };

  handleWorkOrderNameSave = () => {
    this.props.dispatch(
      saveWorkOrderNameRequest(
        this.props.currentWorkOrder.id,
        this.props.workOrderNameValue
      )
    );
  };

  render() {
    // Only render if the current loaded WO is the one specified in the route
    const showContent =
      this.props.currentWorkOrder !== null &&
      this.props.currentWorkOrder.id === this.workOrderId;
    let workOrderTitle = '';
    if (showContent) {
      workOrderTitle = `WO #${this.props.currentWorkOrder.number}`;
      if (this.props.currentWorkOrder.name !== null) {
        workOrderTitle += `: ${this.props.currentWorkOrder.name}`;
      }
    }
    return (
      showContent && (
        <div className="work-order-details">
          <RouteTitle titles={['WORK ORDERS', workOrderTitle]} />

          {this.showTransfer() && <TransferWorkOrder />}

          <WorkOrderDetailsHeader />

          {this.userIsAdmin && (
            <div className="work-order-value-editor-container">
              <div>
                <WorkOrderValueEditor
                  canEdit={this.userIsSpackleAdmin}
                  edit={this.props.workOrderNameEdit}
                  label="name"
                  saving={this.props.workOrderNameSaving}
                  value={this.props.workOrderNameValue}
                  onEdit={this.handleWorkOrderNameEdit}
                  onSave={this.handleWorkOrderNameSave}
                  onValueChange={this.handleWorkOrderNameChange}
                />
              </div>
            </div>
          )}

          {this.showJobNumber(this.props.currentWorkOrder) && (
            <div className="work-order-value-editor-container">
              <div>
                <WorkOrderValueEditor
                  edit={this.props.workOrderJobNumberEdit}
                  label="job reference"
                  saving={this.props.workOrderJobNumberSaving}
                  value={this.props.workOrderJobNumberValue}
                  onEdit={this.handleWorkOrderJobNumberEdit}
                  onSave={this.handleWorkOrderJobNumberSave}
                  onValueChange={this.handleWorkOrderJobNumberChange}
                />
              </div>
            </div>
          )}

          <WorkOrderDetailsInfo />

          <div className="content-container">
            <NavigationBar
              items={[
                {
                  id: 1,
                  title: 'Tasks',
                  total: this.props.tasks.length,
                },
                {
                  id: 5,
                  show: this.showBudgetTab(),
                  title: 'Preliminary Estimate',
                  total: this.props.budget !== null ? 1 : 0,
                },
                {
                  id: 2,
                  show:
                    PermissionsUtil.adminUserCanSeeMoney(this.props.user) ||
                    this.userIsClient ||
                    this.userIsGc,
                  title: 'Quotes',
                  total: this.userIsClient
                    ? this.props.proposals.length
                    : this.props.quotes.length,
                },
                {
                  id: 14,
                  show: this.showAcrTab(),
                  title: 'ACR',
                  total: 1,
                },
                {
                  id: 6,
                  show: this.showPurchaseOrderTab(),
                  title: 'Purchase Order',
                  total: WorkOrder.hasPurchaseOrder(this.props.currentWorkOrder)
                    ? 1
                    : 0,
                },
                {
                  id: 3,
                  show: WorkOrderDetails.showMembers(
                    this.props.currentWorkOrder.status,
                    this.props.user
                  ),
                  title: 'Members',
                  total: this.props.members.length,
                },
                {
                  id: 4,
                  show: this.showOpenItems(),
                  title: 'Open Items',
                  total:
                    this.props.openItemsByTaskId !== null
                      ? Object.values(this.props.openItemsByTaskId)
                          .reduce(
                            (accumulator, currentValue) =>
                              accumulator.concat(currentValue),
                            []
                          )
                          .filter((openItem) => !openItem.resolved).length
                      : 0,
                },
                {
                  id: 13,
                  show: this.showScheduleTab(),
                  title: 'Schedule',
                  total: 1,
                },
                {
                  id: 8,
                  show: this.showContractorLienRelease(
                    this.props.contractorInvoice
                  ),
                  title: 'Unconditional Lien Release',
                  total: this.props.contractorLienRelease !== null ? 1 : 0,
                },
                {
                  id: 9,
                  show: this.showContractorLienReleasesTable(
                    this.props.currentWorkOrder
                  ),
                  title: 'Unconditional Lien Releases',
                  total: this.props.contractorLienReleases.length,
                },
                {
                  id: 10,
                  show: this.showReceiptsTable(),
                  title: 'Materials',
                  total: this.props.receipts.length,
                },
                {
                  id: 11,
                  show: this.showTimeTable(),
                  title: 'Time',
                  total: this.props.time.length,
                },
                {
                  id: 12,
                  show: this.showVendorInvoices(),
                  title: 'Vendors',
                  total: this.props.vendorInvoices.length,
                },
                {
                  id: 15,
                  show: this.props.workOrderAuthorizations.length > 0,
                  title: 'WOAs',
                  total: this.props.workOrderAuthorizations.length,
                },
                {
                  id: 7,
                  show: this.showContractorInvoice(),
                  title: 'Spackle Invoice',
                  total: this.props.contractorInvoice !== null ? 1 : 0,
                },
              ]}
              onSelected={this.handleNavigationItemSelect}
            />

            <div className="separator">
              <div className="clearfix" />
            </div>

            {/*Navigation bar items content*/}
            {this.props.navigationBarSelectedItem === 1 && <DetailsTasks />}
            {this.props.navigationBarSelectedItem === 2 && <DetailsQuotes />}
            {this.props.navigationBarSelectedItem === 3 && <DetailsMembers />}
            {this.props.navigationBarSelectedItem === 4 && <DetailsOpenItems />}
            {this.props.navigationBarSelectedItem === 5 && <DetailsBudget />}
            {this.props.navigationBarSelectedItem === 6 && (
              <DetailsPurchaseOrder />
            )}
            {this.props.navigationBarSelectedItem === 7 && (
              <DetailsContractorsInvoices />
            )}
            {this.props.navigationBarSelectedItem === 8 && (
              <DetailsContractorsLienReleases />
            )}
            {this.props.navigationBarSelectedItem === 9 && (
              <DetailsContractorsLienReleasesTable />
            )}
            {this.props.navigationBarSelectedItem === 10 && <ReceiptsTable />}
            {this.props.navigationBarSelectedItem === 11 && <TimeTable />}
            {this.props.navigationBarSelectedItem === 12 && (
              <VendorInvoicesDetails />
            )}
            {this.props.navigationBarSelectedItem === 13 && <DetailsSchedule />}
            {this.props.navigationBarSelectedItem === 14 && (
              <AnticipatedCostReport />
            )}
            {this.props.navigationBarSelectedItem === 15 && (
              <WorkOrderAuthorizations />
            )}

            {/*Show Add Member button (only if WO not complete)*/}
            {this.props.navigationBarSelectedItem === 3 &&
              !WorkOrderStatusEnum.COMPLETE.equals(
                WorkOrderStatusEnum.create(this.props.currentWorkOrder.status)
              ) && (
                <div>
                  <input
                    className="btn button button-orange btn-add-member"
                    type="button"
                    value="Add Member"
                    onClick={this.handleAddMember}
                  />
                </div>
              )}
          </div>

          {this.props.selectedProposalId !== null &&
            this.props.proposals.length > 0 && <ProposalApprovalModal />}
          {this.props.selectedChangeOrderId !== null &&
            this.props.changeOrders.length > 0 && <ChangeOrderApprovalModal />}
          {this.props.budget !== null && <BudgetApproveReviewModal />}
        </div>
      )
    );
  }

  static showMembers(status, user) {
    if (usersUtil.hasType(user, TYPES.CONTRACTOR)) {
      return (
        WorkOrder.isStatusFulFilled({ status }, WorkOrderStatusKeys.PENDING) &&
        status !== WorkOrderStatusKeys.COMPLETE
      );
    }

    if (
      usersUtil.isAdmin(user) ||
      usersUtil.hasType(user, TYPES.GENERAL_CONTRACTOR)
    ) {
      return (
        status === WorkOrderStatusKeys.IN_PROGRESS ||
        status === WorkOrderStatusKeys.COMPLETE
      );
    }
  }

  showContractorInvoice() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      this.contractorUserCanSeeMoney &&
      (WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum) ||
        WorkOrderStatusEnum.COMPLETE.equals(statusEnum) ||
        WorkOrderStatusEnum.CLOSED.equals(statusEnum))
    );
  }

  showContractorLienRelease(contractorInvoice) {
    // Contractor invoice is paid
    return (
      this.contractorUserCanSeeMoney &&
      contractorInvoice !== null &&
      contractorInvoice.status === 'paid'
    );
  }

  showContractorLienReleasesTable(workOrder) {
    const statusEnum = WorkOrderStatusEnum.create(workOrder.status);
    return (
      this.userIsAdmin &&
      (WorkOrderStatusEnum.COMPLETE.equals(statusEnum) ||
        WorkOrderStatusEnum.CLOSED.equals(statusEnum))
    );
  }

  showJobNumber(workOrder) {
    return (
      this.userIsContractor &&
      WorkOrder.isStatusFulFilled(workOrder, WorkOrderStatusKeys.IN_PROGRESS)
    );
  }

  showOpenItems() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      (WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum) ||
        WorkOrderStatusEnum.COMPLETE.equals(statusEnum) ||
        WorkOrderStatusEnum.CLOSED.equals(statusEnum)) &&
      (this.userIsAdmin || this.userIsContractor)
    );
  }

  showScheduleTab() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      (WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum) ||
        WorkOrderStatusEnum.COMPLETE.equals(statusEnum)) &&
      this.userIsAdmin
    );
  }

  showAcrTab() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      (WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum) ||
        WorkOrderStatusEnum.COMPLETE.equals(statusEnum)) &&
      this.userIsAdmin &&
      this.adminUserCanSeeMoney
    );
  }

  showPurchaseOrderTab() {
    let result = false;
    if (
      this.props.proposals.length > 0 &&
      this.props.currentWorkOrder.client.po_required
    ) {
      // Show if last proposal is approved and current user is admin or client
      result =
        ProposalStatus.APPROVED.equals(
          this.props.proposals[this.props.proposals.length - 1].status
        ) &&
        (this.userIsAdmin || this.userIsClient);
    }

    return result;
  }

  showBudgetTab() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      (WorkOrderStatusEnum.PENDING.equals(statusEnum) ||
        WorkOrderStatusEnum.PLM.equals(statusEnum)) &&
      (PermissionsUtil.adminUserCanSeeMoney(this.props.user) ||
        this.userIsClient ||
        this.userIsGc)
    );
  }

  showReceiptsTable() {
    return this.userIsContractor;
  }

  showTimeTable() {
    return this.userIsContractor;
  }

  showTransfer() {
    return (
      this.userIsAdmin &&
      !WorkOrder.isStatusFulFilled(
        this.props.currentWorkOrder,
        WorkOrderStatusKeys.IN_PROGRESS
      ) &&
      !this.userIsGc
    );
  }

  showVendorInvoices() {
    return this.userIsContractor;
  }
}

export default connect((state) => {
  return {
    budget: getBudget(state),
    contractorInvoice: getContractorInvoice(state),
    contractorLienRelease: getContractorLienRelease(state),
    contractorLienReleases: getContractorLienReleases(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    members: getMembers(state),
    navigationBarSelectedItem: getNavigationBarSelectedItem(state),
    openItemsByTaskId: getOpenItemsByTaskId(state),
    proposals: getProposals(state),
    quotes: getQuotes(state),
    receipts: receiptsSelector(state),
    selectedProposalId: getSelectedProposalId(state),
    tasks: getTasks(state),
    time: timeSelector(state),
    user: getCurrentUser(state),
    vendorInvoices: vendorInvoicesSelector(state),
    workOrderNameEdit: getWorkOrderNameEdit(state),
    workOrderNameSaving: getWorkOrderNameSaving(state),
    workOrderNameValue: getWorkOrderNameValue(state),
    workOrderJobNumberEdit: getWorkOrderJobNumberEdit(state),
    workOrderJobNumberSaving: getWorkOrderJobNumberSaving(state),
    workOrderJobNumberValue: getWorkOrderJobNumberValue(state),
    changeOrders: getChangeOrders(state),
    selectedChangeOrderId: getSelectedChangeOrderId(state),
    workOrderAuthorizations: getWorkOrderAuthorizations(state),
  };
})(WorkOrderDetails);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/WorkOrderDetails.js